import { Clock3, Mail, MapPin, PhoneCall } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { contactPageData } from "../../data/contactData";

const typeIcons = {
  phone: PhoneCall,
  email: Mail,
  address: MapPin,
  hours: Clock3
};

function ContactDetailsSection() {
  const { details } = contactPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Contact Details"
          title="Reach Us Through the Channel You Prefer"
          description="Whether you want a quick call, a detailed email discussion, or an office visit, we are here to support you."
        />

        <div className="relative mt-10 overflow-hidden rounded-[2rem] border border-midnight-navy/10 bg-white/70 p-4 shadow-soft md:p-6">
          <div className="absolute -left-10 top-0 h-40 w-40 rounded-full bg-royal-blue/12 blur-3xl" />
          <div className="absolute -right-12 bottom-0 h-44 w-44 rounded-full bg-warm-gold/16 blur-3xl" />

          <div className="relative grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {details.map((item) => {
            const Icon = typeIcons[item.type] || PhoneCall;
            const isExternal = /^https?:\/\//.test(item.href || "");

            return (
              <article
                key={`${item.label}-${item.value}`}
                className="group rounded-2xl border border-midnight-navy/10 bg-white/90 p-6 shadow-soft transition duration-300 hover:-translate-y-1.5 hover:border-royal-blue/30 hover:shadow-luxury"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sky-glow text-royal-blue transition group-hover:bg-royal-blue group-hover:text-soft-white">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <p className="mt-4 text-xs font-semibold uppercase tracking-[0.12em] text-slate-text/70">
                  {item.label}
                </p>
                <p className="mt-1 text-base font-medium text-midnight-navy">{item.value}</p>
                <a
                  href={item.href}
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noreferrer" : undefined}
                  className="mt-4 inline-flex text-sm font-semibold text-royal-blue hover:text-midnight-navy"
                >
                  {item.actionLabel}
                </a>
              </article>
            );
          })}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default ContactDetailsSection;
